'use strict';

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('material-ui/styles');

var _Form = require('material-ui/Form');

var _Checkbox = require('material-ui/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return (0, _from2.default)(arr); } }

var styles = function styles() {
  return {
    labelStyle: {
      minHeight: '32px',
      marginBottom: '20px',
      fontFamily: 'Heebo, sans-serif',
      fontSize: '26px',
      lineHeight: '32px',
      fontWeight: '400',
      letterSpacing: '0.41px'
    }
  };
};

var CheckboxGroup = function CheckboxGroup(_ref) {
  var input = _ref.input,
      formLabel = _ref.label,
      helperText = _ref.helperText,
      required = _ref.required,
      options = _ref.options,
      classes = _ref.classes,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error;
  return _react2.default.createElement(
    _Form.FormControl,
    { required: required, error: Boolean(touched && error) },
    _react2.default.createElement(
      _Form.FormLabel,
      { classes: { root: classes.labelStyle } },
      formLabel
    ),
    helperText ? _react2.default.createElement(
      _Form.FormHelperText,
      null,
      helperText
    ) : null,
    options.map(function (_ref2) {
      var label = _ref2.label,
          value = _ref2.value;
      return _react2.default.createElement(
        'div',
        { key: value, style: { float: 'left', padding: '8px 0' } },
        _react2.default.createElement(_Form.FormControlLabel, {
          style: { textAlign: 'left' },
          control: _react2.default.createElement(_Checkbox2.default, {
            checked: input.value.includes(value),
            onChange: function onChange(e, checked) {
              var newValue = [].concat(_toConsumableArray(input.value));

              if (checked) {
                newValue.push(value);
              } else {
                (0, _lodash.pull)(newValue, value);
              }

              return input.onChange(newValue);
            }
          }),
          label: label
        })
      );
    }),
    touched && error ? _react2.default.createElement(
      _Form.FormHelperText,
      { error: true },
      error
    ) : null
  );
};

CheckboxGroup.propTypes = {
  input: _propTypes2.default.object.isRequired,
  label: _propTypes2.default.node.isRequired,
  helperText: _propTypes2.default.string,
  options: _propTypes2.default.array.isRequired,
  required: _propTypes2.default.bool,
  classes: _propTypes2.default.object.isRequired,
  meta: _propTypes2.default.object.isRequired
};

CheckboxGroup.defaultProps = {
  required: false,
  helperText: null
};

exports.default = (0, _styles.withStyles)(styles)(CheckboxGroup);